﻿import React, { useEffect } from 'react'
import { withStyles, createStyles } from '@mui/styles'
import { Paper } from '@mui/material'
import { muiOptions, MuiProps } from '../../infrastructure/materialUiThemeProvider'
import { t } from '../../infrastructure/i18nextHelper'
import { MultipleSelect, GroupedMultiSelect, DateRangePicker, Switch } from '../common/customComponents'
import { MktSalesContainer } from './mktSalesStore'
import { MktSaleDemandPlan } from './_mktSalesDemandPlan'
import { hasFeature } from '../../infrastructure/feature'
import { MktSalesFiltersContainer } from './mktSalesFiltersStore'

function _MktSalesFilters({ classes }: MuiProps) {
    let store = MktSalesContainer.useContainer()
    let filterStore = MktSalesFiltersContainer.useContainer()

    useEffect(() => {
        store.loadMktSaleMovements()
    }, [filterStore.selectedValues])

    useEffect(() => {
        filterStore.loadFilters()
    }, [])

    return (
        <div className={classes.bar}>
            <Switch changeCallback={() => filterStore.setUseSiteInPercentageCompute(!filterStore.useSiteInPercentageCompute)} 
                    isChecked={filterStore.useSiteInPercentageCompute}
                    onText={t('mktSales.forecast.sitePercentage')}
                    offText={t('mktSales.forecast.sapPercentage')} />
            {hasFeature('ShortageManagementPlanned') && hasFeature('MktSalesDemandManagement') &&
                <Paper>
                    <MktSaleDemandPlan />
                </Paper >
            }
            <Paper className={classes.paperFilter}>
                <DateRangePicker
                    disableNewStyle
                    startDate={filterStore.startDate || null}
                    endDate={filterStore.endDate || null}
                    startLabel={t('stock.filters.startDate')}
                    endLabel={t('stock.filters.endDate')}
                    onPeriodChange={({ startDate, endDate }) => store.changePeriod(startDate, endDate)}
                />
                <MultipleSelect label={t('mktSales.forecast.company')} classesOverride={{ form: classes.filterField }}
                                filter={filterStore.companiesFilter} onChange={filterStore.handleCompanySelection}/>
                {filterStore.productIdsFilter.items.every(x => !x.productGroup)
                    ? <MultipleSelect hideOnSingleChoice label={t('mktSales.forecast.product')} classesOverride={{ form: classes.filterField }} filter={filterStore.productIdsFilter} />
                    : <GroupedMultiSelect hideOnSingleChoice label={t('mktSales.forecast.product')} classesOverride={{ form: classes.filterField }} filter={filterStore.productIdsFilter}/>
                }
                <GroupedMultiSelect
                    label={t('mktSales.forecast.site')}
                    classesOverride={{ form: classes.filterField }}
                    filter={filterStore.sitesFilter} />
                <GroupedMultiSelect
                    label={t('mktSales.forecast.channel')}
                    classesOverride={{ form: classes.filterField }}
                    filter={filterStore.customerSegmentsFilter}
                    onChange={filterStore.handleCustomerSegmentSelection}
                />
            </Paper>
        </div>
    )
}

let styles = _ =>
    createStyles({
        paperFilter: {
            height: 'auto',
            padding: '0.5em',
        },
        filterField: {
            width: '8.3em',
            margin: '0em 0.5em'
        },
        filterFieldDate: {
            width: '10.3em',
            margin: '0em 0.5em'
        },
        bar: {
            height: '4em',
            width: '100%',
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'flex-start',
            '& > *': {
                height: '100%',
                padding: '0em 0.3em',
                display: 'flex',
                alignItems: 'center',
                marginRight: '1em',
                '&:last-child': {
                    marginRight: '0em'
                }
            },
        }
    })

export let MktSalesFilters = withStyles(styles, muiOptions)(_MktSalesFilters)